import { QueryClient, useQuery } from '@tanstack/react-query';

import { useHoofdstuk } from '../hoofdstuk';

type QueryOptions = {
  enabled?: boolean;
};

const getHoofdstukByLineageIdQueryOptions = (
  hoofdstukLineageId: string,
  options: QueryOptions = {}
) => {
  return useHoofdstuk.getOptions(
    {
      page: 1,
      size: 1,
      filter: [
        {
          model: 'Hoofdstuk',
          field: 'Lineage',
          op: 'eq',
          value: hoofdstukLineageId,
        },
        {
          model: 'Hoofdstuk',
          field: 'Volgend',
          op: 'is_null',
          value: '',
        },
      ],
    },
    {
      select: (response) => response.objects?.[0],
      ...options,
    }
  );
};

const useHoofdstukByLineageId = (
  hoofdstukLineageId: string,
  options: QueryOptions = {}
) => {
  return useQuery(
    getHoofdstukByLineageIdQueryOptions(hoofdstukLineageId, options)
  );
};

const ensureQueryDataHoofdstukByLineageId = async (
  hoofdstukLineageId: string,
  queryClient: QueryClient
) => {
  const response = await queryClient.ensureQueryData(
    getHoofdstukByLineageIdQueryOptions(hoofdstukLineageId)
  );

  return response.objects?.[0];
};

useHoofdstukByLineageId.getOptions = getHoofdstukByLineageIdQueryOptions;

export { useHoofdstukByLineageId, ensureQueryDataHoofdstukByLineageId };
